/* libs/shared/src/lib/ui/draggable-table-regulations/draggable-table-regulations.component.scss */
.ngx-datatable.material {
  box-shadow: none;
}
.edit-button-wrapper {
  position: absolute;
}
.save-button {
  position: absolute;
  right: 30px;
  top: 2px;
}
/*# sourceMappingURL=draggable-table-regulations.component.css.map */
